<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Reports
        <small>Analytics and insights for your inventory</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> IMS / <span class="current">Reports</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <button class="btn btn-outline btn-sm" (click)="exportAll()">
        <i class="bi bi-download"></i> Export All
      </button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing reports for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="reports-index-grid">
    <a
      *ngFor="let report of reports"
      [routerLink]="report.route"
      class="report-link-card"
    >
      <span class="report-link-icon" [style.color]="report.color">
        <i class="bi" [class]="'bi ' + report.icon"></i>
      </span>
      <div class="report-link-body">
        <h2>{{ report.title }}</h2>
        <p>{{ report.description }}</p>
      </div>
    </a>
  </div>
</div>
